module.exports = __webpack_public_path__ + "dec054e8fe1f4c5cfca33c6d7640675b.svg";